import { fetchTell } from 'api';
import { useQuery } from 'react-query';

function useTellFetch() {
  return useQuery({
    queryKey: ['tell'],
    queryFn: fetchTell,
  });
}

export default useTellFetch;
